module.exports = __webpack_public_path__ + "img/9788983947352.78e3036a.jpg";